import e from"./RelevantSort.vue_vue&type=script&lang.js";import{render as t}from"./RelevantSort.vue_vue&type=template&id=d83cf556&lang.js";e.render=t;export default e;
//# sourceMappingURL=RelevantSort.vue.js.map
